module.exports = __webpack_public_path__ + "082b8395add03418e651e8b1f37dc264.png";